<template>
  <div id="joinForm">
    <common-member-form :from="'joinForm'"/>
  </div>
</template>

<script>
import CommonMemberForm from '../common/CommonMemberForm.vue'

export default {
  components: { CommonMemberForm }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/join/JoinForm.vue